export { MovieRatingsContainer } from './MovieRatingsContainer'
